import React from 'react';
import { MapGeneralController } from 'src/feature-app';
import { JourneyEmpresasController } from '.';

/**
 * Este componente está creado únicamente para que JourneyEmpresasController tenga acceso a las variables de MapGeneralController.
 */
export const JourneyEmpresasWrapper = () => {
	return (
		<MapGeneralController>
			<JourneyEmpresasController />
		</MapGeneralController>
	);
};
